(function () {var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;enterModule && enterModule(module);})();var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {return a;};




















export const updateExternalFormData = (
setDataMask = () => {},
pageNumber,
pageSize) =>

setDataMask({
  ownState: {
    currentPage: pageNumber,
    pageSize } });;(function () {var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;if (!reactHotLoader) {return;}reactHotLoader.register(updateExternalFormData, "updateExternalFormData", "/Users/ville/src/superset-release/superset-frontend/plugins/plugin-chart-table/src/DataTable/utils/externalAPIs.ts");})();;(function () {var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;leaveModule && leaveModule(module);})();